export const api_url = 'https://admin.be-safe.ge/api'